import { analytics } from 'moet-core';

export const ANALYTICS_EVENTS = {
  applicationConfirmation: new analytics.Event({
    name: 'Application Submitted',
    description: 'Merchant accepts TOC & submits application',
    action: analytics.EVENT_ACTION.FORM_SUBMIT,
    category: analytics.EVENT_CATEGORY.FLOW_STEP,
    type: analytics.EVENT_TYPE.USER_PREFERENCE,
    properties: [],
  }),
  editInformaiton: new analytics.Event({
    name: 'Information Editted',
    description: 'Merchant edit application information',
    action: analytics.EVENT_ACTION.CTA_CLICK,
    category: analytics.EVENT_CATEGORY.FLOW_STEP,
    type: analytics.EVENT_TYPE.USER_PREFERENCE,
    properties: ['section'],
    userAttributes: ['section'],
  }),
  openPricingTable: new analytics.Event({
    name: 'Pricing Tabled Opened',
    description: 'Merchant open pricing table',
    action: analytics.EVENT_ACTION.CTA_CLICK,
    category: analytics.EVENT_CATEGORY.FLOW_STEP,
    type: analytics.EVENT_TYPE.USER_PREFERENCE,
    properties: [],
    userAttributes: [],
  }),
  openMerchantAgreement: new analytics.Event({
    name: 'Merchant Agreement Opened',
    description: 'Merchant open merchant agreement',
    action: analytics.EVENT_ACTION.CTA_CLICK,
    category: analytics.EVENT_CATEGORY.FLOW_STEP,
    type: analytics.EVENT_TYPE.USER_PREFERENCE,
    properties: [],
    userAttributes: [],
  }),
  openPricingTerms: new analytics.Event({
    name: 'Pricing Terms Opened',
    description: 'Merchant open pricing terms',
    action: analytics.EVENT_ACTION.CTA_CLICK,
    category: analytics.EVENT_CATEGORY.FLOW_STEP,
    type: analytics.EVENT_TYPE.USER_PREFERENCE,
    properties: [],
    userAttributes: [],
  }),
};
